export const getNewMessagePreviewPopupCount = state => state.newMessagePreviewPopup.count;